// printers/TsolesPrinter.ts
import { BasePrinter, PrinterConnectionResult } from './BasePrinter';

export class TsolesPrinter extends BasePrinter {
  readonly type = 'tsoles';

  async checkPrinterConnection(ip: string): Promise<PrinterConnectionResult> {
    try {
      const res = await this.fetchWithTimeout(
        `https://${ip}/machine/status`,
        {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
        },
      }
      );

      return res.ok
        ? {
            ip,
            type: this.type,
            success: true,
            message: 'Printer is reachable.',
          }
        : {
            ip,
            type: this.type,
            success: false,
            message: `Failed to connect. Please trust the certificate in your browser. ${res.status }`,
          };
    } catch (error) {
      return {
        ip,
        type: this.type,
        success: false,
        message: this.getPrinterNetworkErrorMessage(error),
      };
    }
  }

  async sendGcodeToPrinter(
    designTitle: string,
    gcodeText: string,
    ip: string
  ): Promise<void> {
    if (!gcodeText) {
      throw new Error('No G-code provided');
    }

    const uploadRes = await this.fetchWithTimeout(
      `https://${ip}/machine/file/gcodes/${designTitle}.gcode`,
      {
        method: 'PUT',
        headers: { 'Content-Type': 'text/plain' },
        body: gcodeText,
      }
    );

      if (!uploadRes.ok) {
        throw new Error(`Failed to upload G-code. ${uploadRes.status}`);
      }

    const queueRes = await this.fetchWithTimeout(
      `https://${ip}/machine/tsoles/queue?filename=0:/gcodes/${designTitle}.gcode`,
      { method: 'PUT' }
    );

      if (!queueRes.ok) {
        throw new Error(`Failed to start print queue. ${queueRes.status}`);
      }
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(`Failed to send G-code to printer: ${error.message}`);
      }

      throw new Error('Failed to send G-code to printer. The printer did not respond or the connection failed.');
    }
  }
